module.exports = __webpack_public_path__ + "static/img/chart-subscription1.fc55e684.svg";